<template>
  <div>
    <v-row>
      <v-col cols="12">
        <app-label-group
          label="接続元V番号"
          :value="$filter.emptyTo(connectionInfo.srcVNumber, '-')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <app-label-group
          label="接続元VPN/VNコード"
          :value="connectionInfo.srcVpnVnCode"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <app-label-group
          label="接続先V番号"
          :value="$filter.emptyTo(connectionInfo.dstVNumber, '-')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <app-label-group
          label="接続先VPN/VNコード"
          :value="connectionInfo.dstVpnVnCode"
        />
      </v-col>
    </v-row>
    <template v-if="!isExtranetApproval">
      <v-row>
        <v-col cols="12">
          <app-label-group
            label="PINコード"
            :value="$filter.emptyTo(connectionInfo.pinCode, '-')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <app-label-group
            label="承認ステータス"
            :value="
              isApproval && connectionInfo.approvalState === 'APPLIED'
                ? '未承認'
                : $filter.enumTo(connectionInfo.approvalState, 'approvalState')
            "
          />
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col cols="12">
        <app-label-group
          label="メッセージ"
          :value="$filter.emptyTo(connectionInfo.message, '-')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { ExtranetInfo } from "@/apis/ExtranetApi";

export default defineComponent({
  name: "ConnectionInfoTable",
  props: {
    connectionInfo: {
      type: Object as PropType<ExtranetInfo>,
      required: true,
    },
    /**
     * 承認画面から呼び出されているか判定用
     * true:承認画面から呼び出し false:それ以外から呼び出し
     */
    isExtranetApproval: {
      type: Boolean as PropType<boolean>,
      default: false,
      required: false,
    },
  },
  computed: {
    /** 承認側であればtrueを返却する */
    isApproval(): boolean {
      return (
        this.$store.state.user.contractSummary.vnumber !==
        this.connectionInfo.srcVNumber
      );
    },
  },
});
</script>
